import { useState, useEffect, useRef, useMemo } from 'react';
import { ApiGet } from '../Function';
import TopBar from '../TopBar';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts';
import { titleColor, backgroundMainColor, backgroundSubColor, gridCellBackgroundColor } from '../Color';

const MainFunction = function IntergratedMonitoring({ ChangeMonitoring, setInquiryFunction }) { 
  const gridGap = 30;
  const gridPadding = 30;
  const topBarHeight = 60;
  const gridItemStyle = {
    backgroundColor: backgroundSubColor,
    borderRadius: '10px',
    height: '100%'
  };

  const [gridStyle, setGridStyle] = useState(GetGridStyle());
  const [gridItem, setGridItem] = useState(
    <>
      <div style={gridItemStyle}/>
      <div style={gridItemStyle}/>
    </>
  );

  const [date, setDate] = useState(GetDateTime());
  function GetDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); //월은 0부터 시작하므로 +1
    const day = String(now.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
  useEffect(() => {
    Inquiry();
  }, [date]);

  const chartRefs = useRef([]);  

  useEffect(() => {
    document.title = 'LINE RECYCLE MONITORING';

    let intervalId;

    Inquiry();
     if (ChangeMonitoring === undefined) {
      intervalId = setInterval(() => {
        Inquiry();
      }, 1000 * 60);
    } /*else {
      setInquiryFunction(() => ChangeMonitoring);
    }*/

    async function Resize() {
      setGridItem(<></>);
      Inquiry();
    }

    window.addEventListener('resize', Resize);

    return () => {
      window.removeEventListener('resize', Resize);

      if (intervalId) {
        clearInterval(intervalId);
      }

      for (const chartRef of chartRefs.current) {
        if (chartRef) {
          chartRef.dispose();
        }
      }

      setGridStyle(null);
      setGridItem(null);
    };
  }, []);

  async function Inquiry() {
    const min = `${date} 00:00:01`;
    const max = `${date} 23:59:59`;

    const response = await ApiGet(`${process.env.REACT_APP_API_DOMAIN}line-recycle/intergrated-monitoring?date=${date}`);
    if (response !== null && response.ok) {
      const json = await response.json();
    
      const parentStyle = {
        ...gridItemStyle,
        display: 'grid',
        gap: gridGap,
        backgroundColor: backgroundMainColor,
        width: '100%',
        height: '100%',
      };
      const cellStyle = {
        ...parentStyle, gridTemplateRows: '50px 1fr', gap: 10
      };
      const cellTextStyle = {
        ...gridItemStyle,
        color: titleColor,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 50,
        fontWeight: 'bold',
      };

      const powerChartData = [];
      for (const data of json.powerData) {
        powerChartData.push({ name: data.Date_Time, value: [data.Date_Time, data.M_Amp.toLocaleString()] });
      }

      const siloTempChartData = [];
      for (const data of json.siloTempData) {
        siloTempChartData.push({ name: data.Date_Time, value: [data.Date_Time, data.M_Amp.toLocaleString()] });
      }

      const mxrTempChartData = [];
      for (const data of json.mxrTempData) {
        mxrTempChartData.push({ name: data.Date_Time, value: [data.Date_Time, data.M_Amp.toLocaleString()] });
      }

      const hotSiloLevelChartData = [];
      for (const data of json.hotSiloLevelData) {
        hotSiloLevelChartData.push({ name: data.Date_Time, value: [data.Date_Time, data.M_Amp.toLocaleString()] });
      }

      setGridItem(
        <>
          <div style={{ ...parentStyle, gridTemplateColumns: '1fr 1fr 1fr 180px' }}>
            <div style={cellStyle}>
              <div style={{ ...cellTextStyle, fontSize: 30 }}>
                자재 투입량 (t)
              </div>
              <div style={cellTextStyle}>
                {Number(json.productionData.inputAmount).toLocaleString()}
              </div>
            </div>

            <div style={cellStyle}>
              <div style={{ ...cellTextStyle, fontSize: 30 }}>
                배치수 (횟수)
              </div>
              <div style={cellTextStyle}>
                {json.productionData.batchAmount.toLocaleString()}
              </div>
            </div>

            <div style={cellStyle}>
              <div style={{ ...cellTextStyle, fontSize: 30 }}>
                일일 생산량 (t)
              </div>
              <div style={cellTextStyle}>
                {json.productionData.productionAmount.toLocaleString()}
              </div>
            </div>

            <div style={{ ...cellStyle, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <input 
                type='date'
                style={{ height: 40, backgroundColor: backgroundSubColor, color: titleColor, fontSize: 20, fontWeight: 'bold', colorScheme: 'dark', marginLeft: 10, borderRadius: 10, border: 'none', paddingLeft: 10, paddingRight: 10 }}
                value={date}
                onClick={(e)=>e.currentTarget.showPicker()}
                onChange={(e) => {
                  setDate(e.target.value);
                }}
              />
            </div>
          </div>

          <div style={{ ...parentStyle, gridTemplateColumns: '400px 1fr' }}>
            <div style={cellStyle}>
              <div style={{ ...cellTextStyle, fontSize: 30 }}>
                써지빈 양 (%)
              </div>
              <div style={cellTextStyle}>
                {json.hotSiloLevelData.length > 0 ? json.hotSiloLevelData[json.hotSiloLevelData.length - 1].M_Amp.toLocaleString() : 0}
              </div>
            </div>

            <div style={{ ...gridItemStyle, backgroundColor: backgroundSubColor }}>
              <ReactECharts option={GetLineChartOption(hotSiloLevelChartData, '수위', min, max)} style={{ width: '100%', height: '100%' }} onChartReady={OnChartReady}/>
            </div>
          </div>

          <div style={{ ...parentStyle, gridTemplateColumns: '400px 1fr' }}>
            <div style={cellStyle}>
              <div style={{ ...cellTextStyle, fontSize: 30 }}>
                순환골재 (ºC)
              </div>
              <div style={cellTextStyle}>
                {json.siloTempData.length > 0 ? json.siloTempData[json.siloTempData.length - 1].M_Amp.toLocaleString() : 0}
              </div>
            </div>

            <div style={{ ...gridItemStyle, backgroundColor: backgroundSubColor }}>
              <ReactECharts option={GetLineChartOption(siloTempChartData, '온도', min, max)} style={{ width: '100%', height: '100%' }} onChartReady={OnChartReady}/>
            </div>
          </div>

          <div style={{ ...parentStyle, gridTemplateColumns: '400px 1fr' }}>
            <div style={cellStyle}>
              <div style={{ ...cellTextStyle, fontSize: 30 }}>
                혼합물 (ºC)
              </div>
              <div style={cellTextStyle}>
                {json.mxrTempData.length > 0 ? json.mxrTempData[json.mxrTempData.length - 1].M_Amp.toLocaleString() : 0}
              </div>
            </div>

            <div style={{ ...gridItemStyle, backgroundColor: backgroundSubColor }}>
              <ReactECharts option={GetLineChartOption(mxrTempChartData, '온도', min, max)} style={{ width: '100%', height: '100%' }} onChartReady={OnChartReady}/>
            </div>
          </div>

          <div style={{ ...parentStyle, gridTemplateColumns: '400px 1fr' }}>
            <div style={cellStyle}>
              <div style={{ ...cellTextStyle, fontSize: 30 }}>
                전력 (kW)
              </div>
              <div style={cellTextStyle}>
                {json.powerData.length > 0 ? json.powerData[json.powerData.length - 1].M_Amp.toLocaleString() : 0}
              </div>
            </div>

            <div style={{ ...gridItemStyle, backgroundColor: backgroundSubColor }}>
              <ReactECharts option={GetLineChartOption(powerChartData, '전력량', min, max)} style={{ width: '100%', height: '100%' }} onChartReady={OnChartReady}/>
            </div>
          </div>
        </>
      );
    }
  }
  
  function OnChartReady(instance) {
    chartRefs.current.push(instance);
  }

  function GetLineChartOption(chartData, valueType, min, max) {
    return {
      grid: {
        top: 35,
        left: 70,
        right: 50,
        bottom: 40
      },
      title: {
        text: '',
        left: 'center',
        top: 5,
        textStyle: {
          color: titleColor,
          fontSize: 20
        },
      },
      tooltip: {
        trigger: 'axis',
      },
      xAxis: {
        type: 'time',
        min: min,
        max: max,
        axisLine: {
          lineStyle: {
            color: 'white',
          }
        },
      },
      yAxis: {
        type: 'value',
        //name: 'ºC',
        minInterval: 1,
        axisLine: {
          lineStyle: {
            color: 'white',
          }
        },
        splitLine: {
          show: false,
        },
      },
      series: [
        {
          name: valueType,
          type: 'line',
          data: chartData,
          color: 'rgb(238, 102, 102)',
          smooth: false,
          symbol: 'none',
          label: {
            show: false,
            position: 'insideBottom',
            color: 'white',
            textBorderColor: 'black',
            textBorderWidth: 2,
            fontSize: 15,
            formatter: (params) => {
              return params.value === 0 ? '' : params.value.toLocaleString();
            },
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgba(213,72,120,0.8)'
              },
              {
                offset: 1,
                color: 'rgba(213,72,120,0.3)'
              }
            ])
          },
        },
      ],
    };
  }

  function GetGridStyle() {
    return {
      display: 'grid',
      gap: gridGap,
      padding: gridPadding,
      backgroundColor: backgroundMainColor,
      width: '100vw',
      height: `calc(100vh - ${topBarHeight}px)`,
      boxSizing: 'border-box', //패딩을 포함하여 크기 계산
      overflow: 'auto',
      scrollbarWidth: 'none',
      gridTemplateColumns: '1fr',
      gridTemplateRows: '1fr 1fr 1fr 1fr 1fr'
    };
  }

  const logoContent = <span style={{ color: titleColor, fontSize: 40, fontWeight: 'bold' }}>라인리사이클</span>;

  return (
    <div onContextMenu={(event)=>{ event.preventDefault(); }} style={{ userSelect: 'none', width: '100vw', height: '100vh', backgroundColor: backgroundMainColor }}>
      <TopBar logo={logoContent} title={'일일 생산 통합 모니터링'} ChangeMonitoring={ChangeMonitoring} />

      <div style={gridStyle}>
        {gridItem}
      </div>
    </div>
  );
}

export default MainFunction;